import {TimeSeriesChart, TimeSeriesChartProps} from "../../../lineitems-store/TimeSeriesChart";
import {getLastDateOfPreviousMonth} from "../../../ps-models";
import React from "react";
import {formatValueWithValueType} from "./formatting";
export function NRNTimeSeriesChart(props: TimeSeriesChartProps){
    const timeSeriesChartProps: TimeSeriesChartProps = {...props, options: {...(props?.options ?? {}), projectionsStartDate: new Date(getLastDateOfPreviousMonth()), customValueFormatter: formatValueWithValueType
    }}
    return <TimeSeriesChart {...timeSeriesChartProps} />
}